import SetMembershipPrice from './SetMembershipPrice';

export default SetMembershipPrice;
